<template>
  <div
    class="internet_apply_list"
    :class="{ owner: !isCustomer }"
    v-if="isCompleted"
  >
    <div class="a_list_wrap" v-for="(item, index) in list" :key="index">
      <!-- 사용자, 설치진행일 부터 입금완료 전까지 -->
      <div
        class="a_list_notice"
        v-if="
          isCustomer &&
            getInstallDateCheck(item.installDate) &&
            !item.deposit &&
            item.internetGuaranteed > 0 &&
            item.visible > 0
        "
      >
        <div class="a_list_n_1">
          <img
            :src="require('@/assets/front/images/v2/img_bell_2.png')"
            alt=""
          />
        </div>
        <div class="a_list_n_2">
          {{ item.user.nickname }}님,<br />
          지원금은 잘 받으셨나요?
        </div>
        <div class="a_list_n_3">
          설치희망일 기준 4일({{ depositDeadline }}) 이내에 답변을 주시면,<br />지원금을
          받지 못하셨을때 퍼스가 신속하게 도와 드릴 수 있어요!
        </div>
        <div
          class="btn_confirm"
          @click="goGuaranteeConfirm('CONFIRM', item.id)"
        >
          네, 지원금을 받았어요
        </div>
        <div class="btn_change" @click="goGuaranteeConfirm('CHANGE', item.id)">
          설치일을 변경으로 입금일이 바뀌었어요
        </div>
        <div class="btn_report" @click="goGuaranteeConfirm('REPORT', item.id)">
          지원금을 받는데 문제가 생겼어요
        </div>
      </div>
      <div class="a_list_top">
        <div class="a_list_top_1">
          <div class="txt_1">{{ getCreateAt(item.createdAtDetail) }}</div>
          <div
            class="txt_2"
            :class="{ on: !item.deposit }"
            v-if="item.internetGuaranteed > 0"
          >
            {{ item.deposit === true ? '완료' : '진행중' }}
          </div>
        </div>
        <div
          class="a_list_top_2 pnt"
          v-if="isCustomer"
          @click="goReportStore(item)"
        >
          신고하기
        </div>
        <div
          class="a_list_top_2 pnt"
          v-else
          @click="goReport(item.user.id, item.user.nickname)"
        >
          신고하기
        </div>
      </div>
      <!-- 사용자 -->
      <div class="profile" v-if="isCustomer">
        <div class="n_thumb pnt" @click="goShopDetail(item.storeId)">
          <div class="n_thumb_inner" v-if="item.store.storeProfile">
            <img :src="item.store.storeProfile" alt="" />
            <img
              v-if="item.store.cert === 1"
              class="mark"
              src="@/assets/front/images/new/icon_consent_s.png"
            />
          </div>
          <div class="n_thumb_inner" v-else>
            <img
              :src="setShopProfileImg(item.store.storeName, item.storeId)"
              alt=""
            />
            <img
              v-if="item.store.cert === 1"
              class="mark"
              src="@/assets/front/images/new/icon_consent_s.png"
            />
          </div>
        </div>
        <div class="pro_txt">
          <h1 class="name">{{ item.store.storeName }}</h1>
          <div class="guaranteed_support">
            <!-- <div
              v-if="item.store.internetGuaranteed > 0"
              class="store_guaranteed"
            > -->
            <div class="store_guaranteed" v-if="item.internetGuaranteed > 0">
              <img
                :src="require('@/assets/front/images/v2/tag_guarantee.png')"
                alt=""
              />
            </div>
            <!-- <div
              v-if="item.store.internetSupportType == 'SAME_DAY'"
              class="store_support_type"
            > -->
            <div
              class="store_support_type"
              v-if="item.internetSupportType == 'SAME_DAY'"
            >
              <img
                :src="require('@/assets/front/images/v2/tag_daypayment.png')"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 사장님 -->
      <div class="profile" v-else>
        <div class="n_thumb">
          <div class="n_thumb_inner" v-if="item.user == null">
            <img
              :src="
                require(`@/assets/front/images/v2/profiles/img_profile_0.png`)
              "
              alt=""
            />
          </div>
          <div class="n_thumb_inner" v-else>
            <img
              :src="
                item.user.photoThumb
                  ? item.user.photoThumb
                  : require(`@/assets/front/images/v2/profiles/img_profile_${getProfileNum(
                      item.user.id,
                    )}.png`)
              "
              alt=""
            />
          </div>
        </div>
        <div class="pro_txt">
          <div class="txt_info" v-if="item.user != null">
            <h1 class="name">{{ item.user.nickname }}</h1>
          </div>
          <div class="shop_index">
            <div class="info" v-if="setSubmitDetail(item.createdAtDetail)">
              가입 정보는 신청내역을 눌러 확인해 주세요.
            </div>
            <div class="none" v-else>
              비공개 전환된 내역으로 열람이 불가합니다.
            </div>
          </div>
        </div>
      </div>

      <div class="center_btn">
        <button class="btn_list_1" @click="goApplyDetail(item)">
          <img
            :src="
              require('@/assets/front/images/internet_commerce/i_btn_list_b.svg')
            "
          />
          <span>신청서 보기</span>
        </button>
        <button
          @click="goToReviewWrite(item)"
          class="btn_list_2"
          v-if="isCustomer"
        >
          <img
            :src="
              require('@/assets/front/images/internet_commerce/i_review_write.svg')
            "
          />
          <span>리뷰 작성하기</span>
        </button>
        <button @click="goToReview(item.storeId)" class="btn_list_2" v-else>
          <img
            :src="
              require('@/assets/front/images/internet_commerce/i_review_write.svg')
            "
          />
          <span>리뷰 바로가기</span>
        </button>
        <button @click="enterChatRoom(item)" class="btn_list_3">
          <img
            :src="
              require('@/assets/front/images/internet_commerce/ic_list_chat_white.svg')
            "
          />
          <span>채팅</span>
        </button>
      </div>
      <div class="con_info">
        <div class="info_list">
          <div class="txt_1">상품구성</div>
          <div class="txt_2">
            {{ item.item
            }}<span v-if="item.phoneTogether == 'PHONE'">+휴대폰</span
            ><span v-else-if="item.phoneTogether == 'USIM'">+USIM</span>
          </div>
        </div>
        <div class="info_list">
          <div class="txt_1">설치지역</div>
          <div class="txt_2">{{ getArea(item.address) }}</div>
        </div>
        <div class="info_list" v-if="item.storeId == 4485">
          <div class="txt_1">총 혜택</div>
          <div class="txt_2">{{ getTotalPrice(item) | comma }}원</div>
        </div>
        <div class="info_list" v-else>
          <div class="txt_1">약속지원금</div>
          <div class="txt_2">{{ item.supportTotal | comma }}원</div>
        </div>
        <div class="info_list">
          <div class="txt_1">설치희망일</div>
          <div class="txt_2">
            <div class="txt_2_1">
              {{ getDate(item.installDate) }}
            </div>
            <div
              class="txt_2_2"
              @click="viewInfoPopup(item.id)"
              v-if="!item.deposit && item.internetGuaranteed > 0 && isCustomer"
            >
              <img
                :src="require('@/assets/front/images/v2/icons/ic_qu_round.svg')"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="item.internetGuaranteed > 0 && isCustomer">
        <div
          class="btn_ing"
          @click="popupView('step1', item)"
          v-if="!item.deposit && !getContractEndCheck(item.installDate)"
        >
          진행 내역 확인하기
        </div>
        <div
          class="btn_change"
          @click="goGuaranteeConfirm('CHANGE', item.id)"
          v-if="!item.deposit && !getContractEndCheck(item.installDate)"
        >
          설치일 변경하기
        </div>
        <div
          class="btn_end"
          @click="popupView('step2', item)"
          v-if="item.deposit || getContractEndCheck(item.installDate)"
        >
          계약 완료
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { ko as dateKo } from 'date-fns/locale';
import promotionCfg from '@common/lib/common/promotionCfg';

export default {
  name: 'component-internet-apply-list',
  description: '인터넷 신청현황',
  components: {},
  props: {
    isCustomer: {
      type: Boolean,
      default: false,
    },
    list: Array,
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  data(props) {
    return {
      depositDeadline: '',
      isCompleted: false,
    };
  },
  created() {
    // this.$nextTick(() => {
    this.isCompleted = true;
    // });
  },
  methods: {
    getContractEndCheck(installDate) {
      // console.log('this.list');
      // console.log(this.list);
      if (!installDate || installDate == null) {
        return false;
      }

      // 오늘날짜
      const now = format(new Date(), 'yyyy-MM-dd');
      const iDate = new Date(installDate);

      // 설치예정일
      const iDays = format(
        new Date(iDate.setDate(iDate.getDate())),
        'yyyy-MM-dd',
      );

      // 설치예정일+3
      const sDays = format(
        new Date(iDate.setDate(iDate.getDate() + 3)),
        'yyyy-MM-dd',
      );

      // 오늘날짜 >= 설치예정일 && 오늘날짜 <= 설치예정일+3
      if (now > sDays) {
        return true;
      } else {
        return false;
      }
    },
    getInstallDateCheck(installDate) {
      if (!installDate || installDate == null) {
        return false;
      }

      // 오늘날짜
      const now = format(new Date(), 'yyyy-MM-dd');
      const iDate = new Date(installDate);

      // 설치예정일
      const iDays = format(
        new Date(iDate.setDate(iDate.getDate())),
        'yyyy-MM-dd',
      );

      // 설치예정일+3
      const sDays = format(
        new Date(iDate.setDate(iDate.getDate() + 3)),
        'yyyy-MM-dd',
      );

      this.depositDeadline = sDays;

      // 오늘날짜 >= 설치예정일 && 오늘날짜 <= 설치예정일+3
      if (now >= iDays && now <= sDays) {
        return true;
      } else {
        return false;
      }
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy.MM.dd');
    },
    setSubmitDetail(createAt) {
      const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const createdAt = new Date(createAt);

      const sDays = format(
        new Date(createdAt.setDate(createdAt.getDate() + 15)),
        'yyyy-MM-dd HH:mm:ss',
      );
      if (now > sDays) {
        return false;
      } else {
        return true;
      }
    },
    goToReview(storeId) {
      this.$emit('review', storeId);
    },
    goToReviewWrite(item) {
      this.$emit('review-write', item);
    },
    goShopDetail(storeId) {
      this.$emit('shop-detail', storeId);
    },
    goApplyDetail(item) {
      if (this.isCustomer) {
        this.$emit('apply-detail', item.id);
      } else {
        this.$emit('internet-voucher', item.id);
      }
    },
    enterChatRoom(item) {
      if (this.isCustomer) {
        if (item.store.storeDel) return;
        this.$emit('enter-chat', item.storeId);
      } else {
        this.$emit('enter-chat', item.chatroomUuid);
      }
    },
    getProfileNum(userId) {
      return util.setProfile(userId);
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '140x140');

      return path;
    },
    // 매장이 사용자 신고
    goReport(userId, userNickName) {
      this.$emit('user-report', userId, userNickName);
    },
    // 고객이 매장 신고
    goReportStore(item) {
      this.$emit('goReportStore', item);
    },
    toBR(str) {
      return util.toBR(str);
    },
    goGuaranteeConfirm(confirmType, applyId) {
      this.$emit('goGuaranteeConfirm', confirmType, applyId);
    },
    popupView(step, item) {
      this.$emit('popupView', step, item);
    },
    viewInfoPopup(applyId) {
      this.$emit('viewInfoPopup', applyId);
    },
    getDate(installDate) {
      if (!installDate || installDate == null) {
        return '-';
      }

      const iDate = new Date(installDate);
      return format(iDate, 'yyyy.MM.dd (E)', { locale: dateKo });
    },
    getArea(address) {
      let strArr = address.split(' ');
      return strArr[0] + ' ' + strArr[1];
    },
    getTotalPrice(item) {
      console.log('getTotalPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      let promotionInfo = promotionCfg.getPriceInfo(item.telecom, telecomItem);

      console.log(promotionInfo);
      return promotionInfo.support + promotionInfo.gift;
    },
    getPromotionItem(item) {
      let itemArr = '';
      let telecomItem = '';
      if (item.item == '100M 인터넷') {
        itemArr = item.item.split(' ');
        telecomItem = itemArr[0];
      } else {
        itemArr = item.item.split('+');
        if (itemArr[0].indexOf('100M') != -1) {
          telecomItem = '100M';
        } else if (itemArr[0].indexOf('500M') != -1) {
          telecomItem = '500M';
        }

        if (itemArr[1].indexOf('TV') != -1) {
          telecomItem += '+TV';
        }
      }
      return telecomItem;
    },
  },
};
</script>

<style></style>
